function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import pick from 'lodash/pick';
import { ParamComponent } from 'panel';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { ButtonAttrs, ButtonEl, buttonParams } from 'common/components/button';
import { SelectEl } from '../select';
import { ChangeEvent, SelectElProps } from '../select/types';
import { Directions } from '../drop-menu/types';
import css from './index.inline.styl';
type SplitButtonParams = SelectElProps[`props`] & ButtonAttrs & {
  handleClick?: (ev: MouseEvent) => void;
  handleSelectChange?: (ev: ChangeEvent) => void;
};
export interface SplitButtonJsxProps {
  params?: SplitButtonParams;
  on?: {
    click?: (ev: MouseEvent) => void;
    change?: (ev: ChangeEvent) => void;
  };
}
export class SplitButton extends ParamComponent<SplitButtonParams, Obj> {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleClick", (ev: MouseEvent) => {
      if (this.params.disabled === false && this.params.handleClick) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        this.params.handleClick(ev);
      }
    });
    _defineProperty(this, "handleSelectChange", (ev: ChangeEvent) => {
      if (this.params.disabled === false && this.params.handleSelectChange) {
        this.params.handleSelectChange(ev);
      }
    });
  }
  get config() {
    return {
      css,
      useShadowDom: true,
      template: () => this.renderTemplate(),
      defaultParams: {
        disabled: false
      },
      params: _objectSpread(_objectSpread({}, buttonParams), {}, {
        disabled: {
          type: Boolean,
          default: false,
          required: false
        },
        handleClick: Function,
        handleSelectChange: Function,
        sections: Array,
        sectionsFn: Function,
        sectionsFromInputFn: Function,
        dropdownBodyRenderer: Function,
        dropdownPositionParent: Object,
        contextPanelPositionParentElement: Object,
        contextPanelTransform: Function
      })
    };
  }
  renderTemplate() {
    const hasOptions = Array.isArray(this.params.sections) && this.params.sections.length > 0;
    return <div sel='.mp-split-button' class={{
      'has-options': hasOptions
    }}>
        <ButtonEl attrs={_objectSpread(_objectSpread({}, pick(this.params, Object.keys(buttonParams))), {}, {
        elref: "primaryButton"
      })} on={{
        click: this.handleClick
      }}>
          {this.innerHTML.trim()}
        </ButtonEl>

        {/* render options select only when there are available options */}
        {hasOptions && <SelectEl attrs={{
        elref: "selectButton",
        disabled: this.params.disabled,
        'show-icon-only-down-caret': true,
        'always-show-caret': true,
        icon: {
          rightIcon: "caret-down"
        },
        theme: this.params.theme as any,
        'menu-width': 0,
        'menu-height': 0,
        'menu-alignment': Directions.DownRight
      }} props={{
        sections: this.params.sections,
        sectionsFn: this.params.sectionsFn,
        sectionsFromInputFn: this.params.sectionsFromInputFn,
        dropdownPositionParent: this,
        dropdownBodyRenderer: this.params.dropdownBodyRenderer,
        contextPanelTransform: this.params.contextPanelTransform,
        contextPanelPositionParentElement: this.params.contextPanelPositionParentElement
      }} on={{
        change: this.handleSelectChange
      }} />}
      </div>;
  }
}
export const SplitButtonEl = defineAndMakeJsxFactory<SplitButtonJsxProps>("mp-split-button", SplitButton);
export const SplitButtonReact = panel2react<SplitButtonJsxProps>("mp-split-button", SplitButton);